module.exports = __webpack_public_path__ + "img/info5.91e6db98.svg";